import { Component } from "react";
import { withRouter } from "../../../../../utils/withRouter";
import { connect } from "react-redux";
import Loader from "../../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import ExhibitorHeader from "../../../../../common_components/exhibitor_module_header";
import ExhibitorTopMenu from "../../../../../common_components/exhibitor_module_topmenu";
import ExhibitorDrawer from "../../../../../common_components/exhibitor_module_drawer";
import Modal from "react-modal";
import { DOC_BASE_URL, toastError } from "../../../../../utils/constants";
class PlantAndBeautification extends Component {

    // Initilized Constructor 
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
        }
    }


    render() {
        const { isLoading } = this.state
        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <ToastContainer />
                <ExhibitorHeader />
                <ExhibitorDrawer />
                <div className="main-content with-dr-container">
                    <div className="">
                        <div className="row">
                            <ExhibitorTopMenu />
                        </div>
                        <div className="row p-2">
                            <div className="col-xl-12 p-1">
                                <div className="card rounded-0 pt-1">
                                    <div className="card-header p-2">
                                        <h3 className="card-title">Plant And Beautification</h3>
                                    </div>
                                    <div className="card-body p-2">
                                        <div className="row">
                                            <div className="col-xl-12 p-0">
                                                <div className="card rounded-0 p-3">
                                                    <div className="card-body p-1">
                                                        <iframe
                                                            id="myIframe"
                                                            // src={`/${sessionStorage.getItem("sessionExhibitionID")}/Rules-and-Regulations.pdf#toolbar=0&navpanes=0`}
                                                            // src={`https://ems_uat.india-itme.com${FurnitureDetailsFilePath}`}
                                                            src={DOC_BASE_URL + '/document/ManualForm/PlantAndBeautification/PlantAndBeautification.png'}
                                                            width="100%"
                                                            style={{ height: '600px' }}
                                                            title="Bing"
                                                        >
                                                            &lt;/div&gt; &lt;div style="height: 200px;"&gt;&lt;/div&gt;
                                                            &lt;/div&gt; &lt;/div&gt; &lt;/div&gt;
                                                        </iframe>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}
export default withRouter(connect(null, {})(PlantAndBeautification))
